import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';

const labelStyles = {
  position: 'absolute',
  top: '-6px',
  left: '11px',
  background: 'white',
  zIndex: 1,
  padding: '0px 4px',
  fontSize: '12px',
};

const useStyles = makeStyles((theme) => ({
  selected: {
    background: 'rgba(0,0,0,0.10)',
    color: '#00377B',
  },
  selectedSecondary: {
    background: '#DCDCDC',
  },
}));

const CollapsibleList = ({
  name,
  component,
  value,
  listitems,
  onClick,
  timeout,
  selectedClass,
  multiLabel,
  options,
  floating = false,
  label,
  disabled = false,
}) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const list = multiLabel ? options : listitems;

  const handleClick = () => {
    if (disabled) {
      return;
    }
    setOpen(!open);
  };
  return (
    <List component={component} aria-labelledby={`list-${name}`}>
      {(value || open || !floating) && label && (
        <div className="float-label" style={labelStyles}>
          {label}
        </div>
      )}
      <ListItem onClick={handleClick}>
        {!value && !open && floating ? (
          <ListItemText primary={label} />
        ) : (
          <ListItemText className="float-label-title" primary={value} />
        )}
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout={timeout} unmountOnExit>
        <List component={'div'} disablePadding>
          {list.map((listItem, index) => {
            const item = multiLabel ? listItem.value : listItem;
            return (
              <ListItem
                key={`list-${index}`}
                onClick={() => {
                  if (value !== item) {
                    onClick(item);
                  }
                  handleClick();
                }}
                className={value === item ? classes[selectedClass] : ''}
                style={{ paddingLeft: '20px', zIndex: 999, backgroundColor: '#fff' }}
              >
                {multiLabel ? (
                  <ListItemText primary={listItem.label} />
                ) : typeof item === 'string' ? (
                  <ListItemText primary={item} />
                ) : (
                  <React.Fragment>
                    <ListItemText primary={item.name} /> <ListItemText primary={item.value} />
                  </React.Fragment>
                )}
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </List>
  );
};

List.defaultProps = {
  component: 'div',
  value: '',
  name: 'list',
  listitems: [],
  timeout: 'auto',
  selectedClass: 'selected',
  label: 'Tipo',
  disabled: false,
};

export { CollapsibleList };
